import NotFoundPage from './pages/not-found.vue'
import Summary from './pages/admin-summary.vue'
import AccessPoint from './pages/access-point.vue'

export default (auth) => {
  return [
    {
      path: '/',
      async (routeTo, routeFrom, resolve, reject) {
        if (auth.uid) {
          if (Object.keys(auth.account).length > 0) {
            // Account created
            if (typeof auth.account.creationStep !== 'undefined') {
              // Here create instance
              return this.navigate('/create/instance/', { reloadAll: true })
            } else {
              // Check roles for last redirect
              if (auth.isAdmin) {
                if (typeof window.ipcRenderer !== 'undefined') {
                  return this.navigate('/admin/local-proxy/', { reloadAll: true })
                } else {
                  return this.navigate('/admin/dashboard/', { reloadAll: true })
                }
              } else if (auth.isObserver) {
                return this.navigate('/admin/access-registrations/', { reloadAll: true })
              } else if (auth.isAccess) {
                return this.navigate('/user/', { reloadAll: true })
              } else {
                return this.navigate('/no-roles/', { reloadAll: true })
              }
            }
          } else {
            return this.navigate('/create/account/', { reloadAll: true }) // FIXME: this loads if logged
          }
        } else {
          return this.navigate('/login/', { reloadAll: true })
        }
      },
    },
    {
      path: '/login/',
      alias: ['/login/create/', '/login', '/login/create'],
      async (routeTo, routeFrom, resolve, reject) {
        if (auth.uid) {
          if (routeTo.path.indexOf('create') > -1) {
            return this.navigate('/create/instance/', { reloadAll: true })
          }
          return this.navigate('/', { reloadAll: true })
        } else {
          const vueComponent = () => import('./pages/login.vue')
          vueComponent().then((vc) => {
            resolve({ component: vc.default })
          })
        }
      },
    },
    {
      path: '/password/',
      alias: '/password',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid || auth.account.shouldSetPass || auth.isRecovering) {
          const vueComponent = () => import('./pages/password.vue')
          vueComponent().then((vc) => {
            resolve({ component: vc.default })
          })
        } else {
          return this.navigate('/', { reloadAll: true })
        }
      },
    },
    {
      path: '/admin/campaigns/',
      alias: '/admin/campaigns',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-campaigns.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/local-proxy/',
      alias: '/admin/local-proxy',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/local-proxy.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/api-settings/',
      alias: '/admin/api-settings',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/api-settings.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/persons/upload/',
      alias: '/admin/persons/upload',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/upload.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/linkNetwork/',
      alias: '/admin/linkNetwork',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid || !auth.account.support) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-link-network.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/devices/',
      alias: '/admin/devices',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid || !auth.account.support) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-devices.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/hardware/',
      alias: '/admin/hardware',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid || !auth.account.support) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-hardware.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/firmware/',
      alias: '/admin/firmware',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid || !auth.account.support) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-firmware.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/no-roles/',
      alias: '/no-roles',
      async (routeTo, routeFrom, resolve, reject) {
        if (auth.account.access && Object.keys(auth.account.access).length) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/no-roles.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/invitations/',
      alias: '/invitations',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/invitations.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/pricing/',
      alias: '/pricing',
      async (routeTo, routeFrom, resolve, reject) {
        const vueComponent = () => import('./pages/pricing.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/hiring/',
      alias: '/hiring',
      async (routeTo, routeFrom, resolve, reject) {
        const vueComponent = () => import('./pages/hiring.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/create/instance/',
      alias: '/create/instance',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        if (typeof auth.account.creationStep === 'undefined') {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/create.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/create/account/',
      alias: '/create/account',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        if (Object.keys(auth.account).length > 0) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/create-account.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/share/',
      alias: '/admin/share',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-share.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/customize/',
      alias: '/admin/customize',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-customize.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/campaign/create/',
      alias: '/admin/campaign/create',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-campaign-create.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/campaign/edit/',
      alias: '/admin/campaign/edit',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-campaign-create.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin-qr-codes/',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-qr-codes.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/update-instance/',
      alias: '/admin/update-instance',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-update-instance.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/access-point-CRUD/',
      alias: '/admin/access-point-CRUD',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-access-point-CRUD.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/persons/',
      alias: '/admin/persons',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-persons.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/billing/',
      alias: '/admin/billing',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-billing.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/billing-popup/',
      alias: '/admin/billing-popup',
      popup: {
        async (routeTo, routeFrom, resolve, reject) {
          const vueComponent = () => import('./pages/admin-billing-popup.vue')
          vueComponent().then(vc => resolve({ component: vc.default }))
        },
      },
    },
    {
      path: '/admin/tags/',
      alias: '/admin/tags',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-tags.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/populations/',
      alias: '/admin/populations',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-populations.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/dashboard/',
      alias: ['/admin/', '/admin'],
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/admin-dashboard.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/access-registrations/',
      alias: ['/admin/access-registrations'],
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/access-registrations.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/access-control/',
      alias: ['/admin/access-control'],
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/access-control.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/admin/summary/',
      alias: '/admin/summary',
      component: Summary,
      keepAlive: true,
    },
    {
      path: '/access-point/',
      alias: '/admin/access-point',
      component: AccessPoint,
      keepAlive: true,
    },
    {
      path: '/user/',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/user.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/userMap/',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/user-map.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/user/campaign/:campaignID',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/user-campaign.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    {
      path: '/guest/',
      async (routeTo, routeFrom, resolve, reject) {
        if (!auth.uid) {
          return this.navigate('/', { reloadAll: true })
        }
        const vueComponent = () => import('./pages/guest.vue')
        vueComponent().then((vc) => {
          resolve({ component: vc.default })
        })
      },
    },
    // {
    //   path: '/user/',
    //   tabs: [
    //     {
    //       path: '/',
    //       id: 'main',
    //       async (routeTo, routeFrom, resolve, reject) {
    //         // const doneTutorial = localStorage.getItem('doneTutorial')
    //         // if (!doneTutorial) {
    //         //   return this.navigate('/tutorial/', { reloadAll: true })
    //         // }
    //         if (!auth.uid || !auth.isAccess) {
    //           return this.navigate('/', { reloadAll: true })
    //         }
    //         const vueComponent = () => import('./pages/user-main.vue')
    //         vueComponent().then(vc => resolve({ component: vc.default }))
    //       },
    //     },
    //     {
    //       path: '/messages/',
    //       id: 'messages',
    //       async (routeTo, routeFrom, resolve, reject) {
    //         const vueComponent = () => import('./pages/user-messages.vue')
    //         vueComponent().then(vc => resolve({ component: vc.default }))
    //       },
    //     }
    //   ],
    //   async (routeTo, routeFrom, resolve, reject) {
    //     const vueComponent = () => import('./pages/user.vue')
    //     vueComponent().then(vc => resolve({ component: vc.default }))
    //   },
    // },
    {
      path: '(.*)',
      component: NotFoundPage,
    }
  ]
}
